<template style="height: 100%;">
  <div class="ExmCon">
    <el-dialog :title="$t('original.languages224')" :visible.sync="dialogTableVisible"  width="38%">
      <div style="margin: 10px;">
        <table style="border-radius: 18px;width: 100%;">
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages225') }}：</td>
            <td class="td_right">{{ Information.CounselorID }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left"> {{ $t('original.languages207') }} ：</td>
            <td class="td_right">{{ Information.VisitorID }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages208') }} ：</td>
            <td class="td_right">{{ Information.ConsultTheme }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left"> {{ $t('original.languages209') }}：</td>
            <td class="td_right">{{ Information.ConsultCntIntroduce }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages170') }}：</td>
            <td class="td_right">{{ Information.ConsultingLongTime }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left"> {{ $t('original.languages226') }}：</td>
            <td class="td_right">{{ Information.ConAddressName }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages212') }}：</td>
            <td class="td_right">{{ Information.ConsultType }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.Name_of_Company') }}：</td>
            <td class="td_right">{{ Information.DeptName }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages213') }}：</td>
            <td class="td_right">
              {{ Information.ConsultingLongCause == '' ? $t('original.languages213') : Information.ConsultingLongCause }}
            </td>
          </tr>
        </table>
        <table style="margin-top:20px; width:100%">
          <tr style="height: 30px;">
            <td class="td_left" >
               {{ $t('original.languages214') }}
            </td>
            <td class="td_right" :style="Information.ConsultingLongState == 1 ? 'color: rgba(0, 136, 255, 1);' : Information.ConsultingLongState == 3
            ? 'color: rgba(242, 75, 78, 1);' : Information.ConsultingLongState == 2 ? 'color: rgba(21, 191, 109, 1); ' : 'color: rgba(141, 141, 141, 1);'">
              {{ Information.ConsultingLongState == 1 ? '待审批' : Information.ConsultingLongState == 3 ? '已拒绝' : Information.ConsultingLongState == 2 ? '已同意' : '已撤销' }}
            </td>
          </tr>
          <tr style="height: 30px;" v-if="Information.ConsultingLongState == 3 && Information.Isshow">
            <td class="td_left"> 原因</td>
            <td class="td_right">{{ Information.ConsultingLongNotes }}</td>
          </tr>
          <tr style="height: 30px;"
            v-if="(Information.ConsultingLongState == 2 || Information.ConsultingLongState == 3) && Information.Isshow">
            <td class="td_left">{{ $t('original.languages192') }}</td>
            <td class="td_right">{{ Information.ApproverID }}</td>
          </tr>
          <tr style="height: 30px;" v-if="(Information.ConsultingLongState == 3 || Information.ConsultingLongState == 2) && Information.Isshow">
            <td class="td_left"> {{ $t('original.languages193') }}</td>
            <td class="td_right">{{ Information.ApproverTime }}</td>
          </tr>
          <tr style="height: 30px;" v-if="Information.ConsultingLongState == 1">
            <td class="td_left"> 原因</td>
            <td class="td_right">
              <el-input maxlength="200" placeholder="原因" type="textarea" v-model="Information.ConsultingLongNotes" resize="none"></el-input>
            </td>
          </tr>
        </table>
        <div class="buttons" style="width: 100%;" v-if="Information.ConsultingLongState == 1">
          <el-button style="margin-top: 20px;margin-left: 40%;" type="primary" :loading="UpdateConsultingLongload" @click=" UpdateConsultingLongState( 3,
          Information.ConsultingLongID,) ">
             {{ $t('original.languages195') }}
          </el-button>
          <el-button type="primary"  :loading="UpdateConsultingLongload" @click="UpdateConsultingLongState(2,Information.ConsultingLongID,)">
             {{ $t('original.languages196') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="$t('original.languages228')"  :visible.sync="dialogVisible1" width="38%">
      <div style="margin: 10px;">
        <table style="border-radius: 18px;width: 100%;">
          <tr>
            <td class="td_left">{{ $t('original.languages225') }}：</td>
            <td class="td_right">{{ Information.CounselorID }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages207') }}：</td>
            <td class="td_right">{{ Information.VisitorID }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.Name_of_Company') }}：</td>
            <td class="td_right">{{ Information.DeptName }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages213') }}：</td>
            <td class="td_right">
              {{ Information.ConsultingLongCause == '' ? $t('original.languages213') : Information.ConsultingLongCause}}
            </td>
          </tr>
        </table>
        <table style="margin-top:20px; width:100%">
          <tr>
            <td class="td_left">
               {{ $t('original.languages214') }}
            </td>
            <td class="td_right" :style="Information.ConsultingLongState == -1 ? 'color: rgba(0, 136, 255, 1);' : Information.ConsultingLongState == 3
                  ? 'color: rgba(242, 75, 78, 1);' : Information.ConsultingLongState == 2 ? 'color: rgba(21, 191, 109, 1); ' : 'color: rgba(141, 141, 141, 1);'">
              {{Information.ConsultingLongState == 1 ?  '待审批' : Information.ConsultingLongState == 3 ? '已拒绝' : Information.ConsultingLongState == 2 ? '已同意' : Information.ConsultingLongState == 4 ? '已撤销' : ''}}
            </td>
          </tr>
          <tr v-if="Information.ConsultingLongState == 3 && Information.Isshow">
            <td class="td_left"> 原因</td>
            <td class="td_right">{{ Information.ConsultingLongNotes }}</td>
          </tr>
          <tr v-if="Information.ConsultingLongState == -1 && Information.Isshow">
            <td class="td_left"> {{ $t('original.languages192') }}</td>
            <td class="td_right">{{ Information.ApproverID }}</td>
          </tr>
          <tr v-if="(Information.ConsultingLongState == 3 || Information.ConsultingLongState == 2) && Information.Isshow">
            <td class="td_left"> {{ $t('original.languages193') }}</td>
            <td class="td_right">{{ Information.ApproverTime }}</td>
          </tr>
          <tr v-if="Information.ConsultingLongState == 1">
            <td class="td_left"> 原因</td>
            <td class="td_right">
              <el-input placeholder="原因" type="textarea" v-model="Information.ConsultingLongNotes"  resize="none"></el-input>
            </td>
          </tr>
        </table>
        <div class="buttons" style="width: 100%;" v-if="Information.ConsultingLongState == 1">
          <el-button type="primary"  @click="UpdateConsultLongApplyState(
          (Information.ConsultingLongState = 0),
          Information.ConLongApplyID,)">
             拒绝
          </el-button>
          <el-button type="primary" @click=" UpdateConsultLongApplyState( (Information.ConsultingLongState = 2), Information.ConLongApplyID,)">
            同意
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-tabs type="border-card" class="list-cnt">
      <el-tab-pane :label="$t('original.languages197')">
        <span slot="label">{{ $t('original.languages197') }}</span>
        <el-button :disabled='spcinu' type="primary" @click="batchfun('1','1')">选中同意</el-button>
        <el-button :disabled='spcinu' type="primary" @click="batchfun('-1','1')">选中拒绝</el-button>
        <el-button :disabled='spcinu' type="success" @click="batchfun('1','2')">全部同意</el-button>
        <el-button :disabled='spcinu' type="danger" @click="batchfun('-1','2')">全部拒绝</el-button>

        <el-table :data="UndoTableData" style="margin-top:15px"  v-loading="IsDataLoad" :element-loading-text="$t('original.languages22')" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('original.The_serial_number')" width="100px" >
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="VisitorID" :label="$t('original.languages229')"></el-table-column>
          <el-table-column  prop="ConsultingLongCause" :label="$t('original.languages213')"></el-table-column>
          <el-table-column prop="CounselorID" :label="$t('original.languages225')"></el-table-column>
          <el-table-column :label="$t('original.languages230')">
            <template slot-scope="scope">
              <span class="state-green" v-if="scope.row.ApplyType == 0">
                {{ $t('original.languages231') }}
              </span>
              <span class="state-red" v-else-if="scope.row.ApplyType == 1">
                {{ $t('original.languages232') }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="CreatedTime" :label="$t('original.languages217')"></el-table-column>
          <el-table-column :label="$t('original.languages214')" width="100">
            <template>
              <span style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;" class="state-blue">
               {{ $t('original.languages200') }}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100" align="center">
            <template slot-scope="scope">
              <span style="color: rgba(0, 136, 255, 1) !important;cursor: pointer;" class="option-blue" @click="handleCheck(scope.row)
              Information.Isshow = false">
               {{ $t('original.languages201') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right;" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="UndoCount" v-if="UndoCount > 0"></el-pagination>
      </el-tab-pane>
      <el-tab-pane :label="$t('original.languages202')">
        <el-table :data="DoTableData" v-loading="IsDataLoad" :element-loading-text="$t('original.languages22')">
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="VisitorID" :label="$t('original.languages229')"></el-table-column>
          <el-table-column prop="ConsultingLongCause" :label="$t('original.languages213')"></el-table-column>
          <el-table-column prop="CounselorID" :label="$t('original.languages225')"></el-table-column>
          <el-table-column prop="CreatedTime" :label="$t('original.languages223')"></el-table-column>
          <el-table-column prop="VisitorID" :label="$t('original.name')"></el-table-column>
          <el-table-column :label="$t('original.languages230')">
            <template slot-scope="scope">
              <span class="state-green" v-if="scope.row.ApplyType == 0">
                 {{ $t('original.languages231') }}
              </span>
              <span class="state-red" v-else-if="scope.row.ApplyType == 1">
                 {{ $t('original.languages232') }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="审批状态" width="100">
            <template slot-scope="scope">
              <span class="state-green" v-if="scope.row.ConsultingLongState == 2" style="color: #fff; background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;">已同意</span>
              <span class="state-red" v-else-if="scope.row.ConsultingLongState == 3" style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">已拒绝</span>
              <span v-else-if="scope.row.ConsultingLongState == 4" class="state-gray">已撤销</span>
            </template>
          </el-table-column>
          <el-table-column prop="ApproverTime" :label="$t('original.languages193')"></el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100">
            <template slot-scope="scope">
              <span class="option-blue copy_Button" @click="handleCheck(scope.row)
               Information.Isshow = true">
                 {{ $t('original.languages174') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px;text-align: right;" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="DoCount" v-if="DoCount > 0"></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      spcinu:false,
      sDataLoad: true,
      dialogTableVisible: false, //打开详情框
      dialogVisible1: false,
      pageSize: 10,
      pageIndex: 1,
      UndoTableData: [],
      DoTableData: [],
      UndoCount: -1,
      DoCount: -1,
      appointmentList: [],
      Information: {
        ConsultingLongID: '',
        VisitorID: '',
        CounselorID: '',
        ConsultingLongCause: '',
        CreatedTime: '',
        ConsultTheme: '',
        ConsultCntIntroduce: '',
        ConsultingLongTime: '',
        ConAddressName: '',
        ConsultType: '',
        DeptName: '',
        ConsultingLongState: '',
        ApproverID: '',
        ApproverTime: '',
        ConsultingLongNotes: '',
        Isshow: false,
      },
      UpdateConsultingLongload:false,
      DeleteKeys:[]
    }
  },
  created() {
    this.GetData()
  },
  methods: {
    batchfun(val,type){
      if(type == 1){
        this.spcinu = true;
        if(this.DeleteKeys.length > 0){
          this.$Http_Post('management/consultsubscribe/batchhandlelongconsult', {handleFlag: val,ids:this.DeleteKeys}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.spcinu = false;
              this.Global.request_successful(res.Message);
              window.location.reload();
            } else {
              this.spcinu = false;
              this.$message.error(res.Message);
            }
          })
        }else{
          alert('请选择选项！');
        }
      }else if(type == 2){//全部
        this.spcinu = true;
        this.$Http_Post('management/consultsubscribe/batchhandlelongconsult', {handleFlag: val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.spcinu = false;
            this.Global.request_successful(res.Message);
            window.location.reload();
          } else {
            this.spcinu = false;
            this.$message.error(res.Message);
          }
        })
      }
    },

    // 全选
    handleSelectionChange(e){
      this.DeleteKeys = [];
      for(let item of e){
        this.DeleteKeys.push(item.ConsultingLongID);
      }
    },
    GetData() {
      this.IsDataLoad = true
      let _this = this
      this.$Http_Post('ConsultSubscribe/GetAllExamineLongConsult', {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.UndoTableData = res.Data.UndoTableData;
          _this.DoTableData = res.Data.DoTableData;
          _this.UndoCount = res.Data.UndoCount;
          _this.DoCount = res.Data.DoCount;
          _this.IsDataLoad = false;
          // _this.$parent.RefreshLongConsultCount(_this.UndoCount);
        }
      })
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetData();
    },
    handleCheck(obj) {
      let _this = this;
      if (obj.ApplyType == 0) {
        _this.dialogTableVisible = true;
        _this.Information.ConsultingLongID = obj.ConsultingLongID;
      } else if (obj.ApplyType == 1) {
        _this.dialogVisible1 = true;
        _this.Information.ConLongApplyID = obj.ConLongApplyID;
      }
      _this.Information.VisitorID = obj.VisitorID;
      _this.Information.CounselorID = obj.CounselorID;
      _this.Information.ConsultingLongCause = obj.ConsultingLongCause;
      _this.Information.CreatedTime = obj.CreatedTime;
      _this.Information.ConsultTheme = obj.ConsultTheme;
      _this.Information.ConsultCntIntroduce = obj.ConsultCntIntroduce;
      _this.Information.ConsultingLongTime = obj.ConsultingLongTime;
      _this.Information.ConAddressName = obj.ConAddressName;
      _this.Information.ConsultType = obj.ConsultType;
      _this.Information.DeptName = obj.DeptName;
      _this.Information.ConsultingLongState = obj.ConsultingLongState;
      _this.Information.ApproverID = obj.ApproverID;
      _this.Information.ApproverName = obj.ApproverName;
      _this.Information.ApproverTime = obj.ApproverTime;
      _this.Information.ConsultingLongNotes = obj.ConsultingLongNotes;
    },
    UpdateConsultLongApplyState(ApplyState, ConLongApplyID) {
      this.$Http_Post('ConsultSubscribe/UpdateConsultLongApply', {
        ConLongApplyID: ConLongApplyID,
        ApplyState: ApplyState,
        ApplyReason: this.Information.ConsultingLongNotes,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.GetData();
          this.Global.request_successful(res.Message);
          this.dialogVisible1 = false;
          // this.$parent.RefreshLongConsultCount(-1);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    UpdateConsultingLongState(ConsultingLongState, ConsultingLongID) {
      let ConsultingLongNotes = '';
      if (ConsultingLongState == 3) {
        ConsultingLongNotes = this.Information.ConsultingLongNotes;
      }
      this.UpdateConsultingLongload = true;
      this.$Http_Post('ConsultSubscribe/UpdateConsultingLong', {ConsultingLongID: ConsultingLongID,ConsultingLongState: ConsultingLongState,ConsultingLongNotes: ConsultingLongNotes}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.dialogTableVisible = false;
          this.UpdateConsultingLongload = false;
          this.GetData();
          // this.$parent.RefreshLongConsultCount(-1);
        } else {
          this.Global.request_failure(res.Message);
        }
        this.UpdateConsultingLongload = false;
      })
    },
  },
}
</script>
<style>
.el-tabs {
  height: 100%;
}
.list-cnt {
  height: 100%;
}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>
